import type { AssetWorkflowOptions } from '../../types';

export const addAddressWorkflow: AssetWorkflowOptions = {
  workflowKey: 'addAddressWorkflow',
  workflowType: 'addAssetWorkflow',
  assetType: 'address',
  workflowIndex: 1,
  workflowName: 'Add an Address to your configuration',
  workflowDescription:
    'In the Shipium System, an address represents a shipping source location, or a returns destination.  Addresses are also used in carrier integration and label generation. Click below to being the process of adding a new address to your configuration.',
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Address ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this address',
        description: 'This is optional but will allow you to more easily reference this address in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'addressName',
      workflowStepNavigationName: 'Address Name',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'What should this Address be named?',
        description: ``,
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'addressDescription',
      workflowStepNavigationName: 'Address Description',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 10,
        defaultValue: '',
        prompt: 'Enter a description (optional):',
        description: ``,
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'addressLocation',
      workflowStepNavigationName: 'Address Location',
      excludeFromNavigation: false,
      refreshAssetsOnStepCompletion: true,
      workflowComponent: {
        workflowComponentType: 'addressLocation',
        entryOnly: true,
        prompt: '',
        description: 'Enter the complete street address:',
        help: '',
        options: [],
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'location',
      },
    },
    {
      workflowStepKey: 'tenantSelect',
      workflowStepNavigationName: 'Tenant Select',
      workflowComponent: {
        assetType: 'tenant',
        workflowComponentType: 'tenantSelect',
        prompt: 'Does this address belong to a specific tenant?',
        description: '',
        help: '',
        optional: true,
      },
      optional: true,
      workflowStepConditionalMatcher: [
        {
          assetType: 'tenant',
          schema: { type: 'array', minItems: 1 },
        },
      ],
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'tenant',
        linkType: 'Tenant',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Address Summary',
        description: 'Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
